import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2707b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fal fa-chevron-right fa-fw",
  style: {"float":"right","color":"gray","font-size":".8em"}
}
const _hoisted_2 = { style: {"text-transform":"capitalize"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-helmet-safety fa-fw" }, null, -1))
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { style: {"color":"gray","padding-left":"22px"} }
const _hoisted_6 = {
  key: 0,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment fa-fw" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "teams"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-clock fa-fw" }, null, -1))
const _hoisted_10 = {
  key: 0,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment fa-fw" }, null, -1))
const _hoisted_12 = {
  key: 0,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment fa-fw" }, null, -1))
const _hoisted_14 = {
  key: 0,
  style: {"font-style":"italic","color":"gray"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-comment fa-fw" }, null, -1))

import {
  IonContent, IonHeader, IonPage, IonButtons, IonMenuButton,
  IonTitle, IonItemGroup, IonItemDivider, IonInfiniteScroll, IonInfiniteScrollContent,
  IonToolbar, IonList, IonItem, IonLabel, IonRefresher, IonRefresherContent, InfiniteScrollCustomEvent, 
  RefresherCustomEvent, onIonViewDidEnter,
} from '@ionic/vue';
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import EmptyState from './components/EmptyState.vue'
import ListSkeletton from './components/ListSkeletton.vue'
import dayjs from 'dayjs';
import { getForegroundForBackground } from '@/helpers/colors';
import { useRouter } from 'vue-router'
import { rangeTimeText } from '@/helpers/date';
import { useI18n } from "vue-i18n";
import { getApi } from '@/helpers/api';
import { PeriodAllocationsApi, PersonPlanningWeek, PersonPlanningDay, DtoCalendarItem } from 'ppf-api-client';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationsPage',
  setup(__props) {

const content = ref<InstanceType<typeof IonContent> | null>(null);
const weeks = ref<PersonPlanningWeek[]>([]);
const loading = ref(true);
const { t } = useI18n();
const service = getApi(PeriodAllocationsApi);
const auth = useAuthStore();
const router = useRouter();



//load inital data when entering the tab
onIonViewDidEnter(() => {
  loading.value = true;
  weeks.value = [];

  refresh().then(() => {
    loading.value = false;
  });
});


/**
 * go to details callback
 * navigate to allocation details for the clicked cell if there are any allocations
 * @param day the allocation day clicked
 */
const goToDetails = function (day: PersonPlanningDay): void {
  if (day.allocations && day.allocations.length > 0 && day.day && day.day.dateTime) {
    router.push(`/allocationsDay/${day.day.dateTime.toISOString()}`);
  }
}

/**
 * Get event range display
 * there are 4 possible cases:
 * - event is all day
 * - start & end are on the same day
 * - start is today and end is another day
 * - end is today and start is another day
 * @param event 
 */
const getEventDateRangeDisplay = function (event: DtoCalendarItem): string {
  if (event.allDay) {
    return '';
  }
  const start = dayjs(event.start);
  const end = dayjs(event.end);
  const now = dayjs(Date.now());
  if (start.isBefore(end, 'day')) {
    if (start.isSame(now, 'day')) {
      return t('g.time.since', { date: start.format('HH:mm') });
    }
    else {
      return t('g.time.until', { date: end.format('HH:mm') });
    }
  } else {
    return t('g.time.range', { since: start.format('HH:mm'), until: end.format('HH:mm') });
  }
}

/**
 * refresh callback
 * @param e 
 */
const onRefresh = async (e: RefresherCustomEvent) => {
  await refresh();
  e.target.complete();
};

/**
 * refresh the displayed list
 * 
 * reinitialize the whole list by refetching data starting now
 */
const refresh = async () => {
  if (service) {
    const items = await service.periodAllocationsWeeksFromDate(auth.userId, new Date(), 4, true);
    //#33276 remove days before the current day
    if (items.weeks.length > 0 && items.weeks[0].days.length > 0) {
      const now = new Date();
      const thisMorning = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      items.weeks[0].days = items.weeks[0].days.filter(d => d.day && d.day.dateTime && d.day.dateTime > thisMorning);
    }
    weeks.value = items.weeks && items.weeks.length > 0 ? items.weeks : [];
  }
};

/**
 * scroll to top callback
 */
const scrollToTop = () => (content.value as any)?.$el.scrollToTop();

/**
 * load 2 more weeks of data and append them to the list
 * @param e 
 */
const loadMoreData = async (e: InfiniteScrollCustomEvent) => {
  if (service && weeks.value.length > 0) {
    const items = await service.periodAllocationsWeeksFromDate(auth.userId, dayjs(new Date()).add(weeks.value.length * 7, 'days').toDate(), 2, true);
    if (items.weeks.length > 0) {
      weeks.value.push(...items.weeks);
    }
  }
  e.target.complete();
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonMenuButton))
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { onClick: scrollToTop }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('p.allocation.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        ref_key: "content",
        ref: content
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRefresher), {
            onIonRefresh: onRefresh,
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRefresherContent))
            ]),
            _: 1
          }),
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, (c) => {
                return (_openBlock(), _createBlock(_unref(IonItemGroup), {
                  key: c.number
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItemDivider), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('p.allocation.week-header', {
              week: c.number, year: c.start ? c.start.getFullYear() : 'N/A'
            })), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.days, (d) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: d.day.dateTime!.toISOString(),
                        button: d.allocations.length > 0,
                        detail: false,
                        onClick: ($event: any) => (goToDetails(d))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              (d.allocations.length > 0)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                                : _createCommentVNode("", true),
                              _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(dayjs)(d.day.dateTime).format('dddd D MMMM')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.allocations, (e, idx) => {
                                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                                  _createElementVNode("p", null, [
                                    _hoisted_3,
                                    _createTextVNode(" " + _toDisplayString(e.name) + " ", 1),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(e.isException ? _unref(rangeTimeText)(e.start, e.end, 'HH:mm') : e.time), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(e.workshop) + " \\ " + _toDisplayString(e.line), 1),
                                  (e.comment)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                        _hoisted_7,
                                        _createTextVNode(" " + _toDisplayString(e.comment), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (d.teams && d.teams.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("ul", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.teams, (e) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: e.name
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.shifts, (s) => {
                                            return (_openBlock(), _createElementBlock("li", { key: s }, _toDisplayString(s), 1))
                                          }), 128))
                                        ], 64))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.events, (e, idx) => {
                                return (_openBlock(), _createElementBlock("p", { key: idx }, [
                                  _createElementVNode("span", {
                                    class: "label",
                                    style: _normalizeStyle({ backgroundColor: e.typeColor || '#000', color: _unref(getForegroundForBackground)(e.typeColor || '#000') })
                                  }, _toDisplayString(e.type), 5),
                                  _createTextVNode(" " + _toDisplayString(getEventDateRangeDisplay(e)), 1)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.transferts, (e, idx) => {
                                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                                  _createElementVNode("span", {
                                    class: "label",
                                    style: _normalizeStyle({ backgroundColor: e.typeColor || '#000', color: _unref(getForegroundForBackground)(e.typeColor || '#000') })
                                  }, _toDisplayString(e.type), 5),
                                  (e.comment)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                        _hoisted_11,
                                        _createTextVNode(" " + _toDisplayString(e.comment), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.assignations, (e, idx) => {
                                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                                  _createElementVNode("span", {
                                    class: "label",
                                    style: _normalizeStyle({ backgroundColor: e.typeColor || '#000', color: _unref(getForegroundForBackground)(e.typeColor || '#000') })
                                  }, _toDisplayString(e.type), 5),
                                  (e.comment)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                        _hoisted_13,
                                        _createTextVNode(" " + _toDisplayString(e.comment), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.reservations, (e, idx) => {
                                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                                  _createElementVNode("span", {
                                    class: "label",
                                    style: _normalizeStyle({ backgroundColor: e.typeColor || '#000', color: _unref(getForegroundForBackground)(e.typeColor || '#000') })
                                  }, _toDisplayString(e.type), 5),
                                  (e.comment)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                        _hoisted_15,
                                        _createTextVNode(" " + _toDisplayString(e.comment), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["button", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInfiniteScroll), { onIonInfinite: loadMoreData }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonInfiniteScrollContent))
            ]),
            _: 1
          }),
          _createVNode(ListSkeletton, {
            style: _normalizeStyle({ display: loading.value ? 'block' : 'none' })
          }, null, 8, ["style"]),
          _createVNode(EmptyState, {
            style: _normalizeStyle({ display: loading.value || weeks.value.length > 0 ? 'none' : 'block' }),
            icon: "fa-user-helmet-safety"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('p.allocation.empty')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}
}

})